import { Mark } from '@/brand/Mark';

/** Shown while a route chunk or the session is still loading. */
export function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite">
      <Mark size={44} animate />
    </div>
  );
}

export default RouteFallback;
